import { useEffect, useMemo } from "react";
import { getRegister, addSelectItem } from "../../utils/helpers";
import { URL_WAGES_PAYMENTS_HISTORY } from "../../utils/urls";
import { API_PAY_WAGES } from "../../utils/apis";
import { CASH, MOBILE_MONEY } from "../../utils/constants";
import { IFormSection, TFormHookParams } from "../../types/common";
import { useLocation } from "react-router-dom";

export const usePayWagesForm = ({
  id,
  form,
  updateFormValues,
}: TFormHookParams & { navigate?: any } = {}) => {
  const location = useLocation();
  const itemData = location.state?.item;

  useEffect(() => {
    if (itemData) {
      updateFormValues({
        wage_calculation_id: itemData.id,
        amount: itemData.total_wage,
      });
    }
  }, [itemData]);

  const fields: any = useMemo(
    () => [
      {
        field_name: "wage_calculation_id",
        type: "text",
        props: {
          required: true,
          disabled: true,
          placeholder: "Wage Calculation Id",
        },
      },
      {
        field_name: "amount",
        type: "number",
        props: {
          required: true,
          disabled: true,
          placeholder: "Enter Amount",
        },
      },
      {
        field_name: "payment_method",
        label: "Payment Method",
        type: "select",
        props: { required: true },
        options_data: [
          addSelectItem({ label: "Mobile Money", value: MOBILE_MONEY }),
          addSelectItem({ label: "Cash", value: CASH }),
        ],
      },
      {
        field_name: "phone_number",
        label: "Phone Number",
        type: "tel",
        visible: form?.payment_method === MOBILE_MONEY,
        props: {
          required: form?.payment_method === MOBILE_MONEY,
          placeholder: "Mobile money number that will receive payment request",
        },
      },
      {
        field_name: "notes",
        label: "Notes",
        type: "text",
        props: {
          required: false,
          placeholder: "Enter comments/notes",
        },
      },
    ],
    [form?.payment_method, itemData],
  );

  const sections: IFormSection[] = useMemo(
    () => [
      {
        title: "Payment Information",
        fields: fields,
      },
    ],
    [fields],
  );

  const title = "Make Payment";
  const redirect = getRegister(URL_WAGES_PAYMENTS_HISTORY);

  const onSubmit = (payload: any) => {
    const transformedPayload = {
      ...payload,
    };

    if (id) {
      // Update existing payment
      return {
        id: id,
        api: API_PAY_WAGES,
        params: transformedPayload,
      };
    }

    // Create new payment
    return {
      api: API_PAY_WAGES,
      params: transformedPayload,
    };
  };

  return {
    fields,
    sections,
    title,
    redirect,
    onSubmit,
    submitText: "Make Payment",
    itemData,
  };
};
